module.exports = "<p>\n  ec2-init-config-tab works!\n</p>\n"